import { sendRequest } from '../../config';

export interface dataToken {
    token: string;
    status: string;
    refreshtoken: string;
}

export const getToken = async (): Promise<dataToken> => {
    const ENDPOINT = 'v2/signosvitales/token';
    return sendRequest({
        method: 'get',
        path: ENDPOINT,
        withCredentials: true,
        skipAuth: true,
    });
};